/* This file is autogenerated, see readme.md for instructions */
import ConstantAltSvgIcon from '@bloomreach/banana-theme/icons/constant-alt.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ConstantAltIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ConstantAltSvgIcon />
    </Icon>
  );
});

ConstantAltIcon.displayName = 'ConstantAltIcon';

export default ConstantAltIcon;
